<template>
  <div>
    <div class="row">
      <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.names')}: *`"
          v-model="model.first_name"
          name="common_words.names"
          v-validate="modelValidations.first_name"
          :error="getError('common_words.names', true)"
          placeholder="..."
        >
        </fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.surnames')}: *`"
          v-model="model.last_name"
          name="common_words.surnames"
          v-validate="modelValidations.last_name"
          :error="getError('common_words.surnames', true)"
          placeholder="..."
        >
        </fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.nit')}: *`"
          v-model="model.nit"
          name="common_words.nit"
          v-validate="modelValidations.nit"
          :error="getError('common_words.nit', true)"
          placeholder="..."
        >
        </fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
        <fg-input
          type="number"
          :label="`${$t('inventory.bank_account')}: *`"
          v-model="model.bank_account"
          name="inventory.bank_account"
          v-validate="modelValidations.bank_account"
          :error="getError('inventory.bank_account', true)"
          placeholder="5554-xxxx-xxxx"
        >
        </fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
        <div class="form-group has-label">
          <label>{{ $t('inventory.account_type') }}: *</label>
          <br />
          <el-select
            clearable
            filterable
            class="select-primary custom-width-select shadow-sm required-account_type"
            size="large"
            v-model="model.account_type"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              class="select-primary"
              v-for="item in getTypeBankAccount"
              :key="item.id + item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
        <fg-input
          type="text"
          :label="`${$t('inventory.bank_name')}: `"
          v-model="model.bank_name"
          name="inventory.bank_name"
          v-validate="modelValidations.bank_name"
          :error="getError('inventory.bank_name', true)"
          placeholder="..."
        >
        </fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-5 col-xl-5">
        <div class="form-group has-label">
          <label>{{ $t('inventory.article_category') }}: *</label>
          <br />
          <el-select
            @change="
              selectAllFromSelect(
                'model.articleCategories_id',
                articleCategories
              ),
                articleByCategories()
            "
            collapse-tags
            clearable
            filterable
            multiple
            class="select-primary custom-width-select shadow-sm required-articleCategories"
            size="large"
            v-model="model.articleCategories_id"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="(option, index) in articleCategories"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="index + option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-7 col-xl-7">
        <div class="form-group has-label">
          <label>{{ $t('inventory.articles') }}: *</label>
          <br />
          <el-select
            @change="selectAllFromSelect('model.articles_id', aticleByCategory)"
            collapse-tags
            clearable
            filterable
            multiple
            :disabled="model.isActiveArticle"
            class="select-primary custom-width-select shadow-sm required-articles"
            size="large"
            v-model="model.articles_id"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="(option, index) in aticleByCategory"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="index + option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12">
        <select-businesses-component
          ref="selectBusiness"
          :requiered="true"
          :initialData="businessesInitial"
          @onChange="updateSelectedBusinesses"
          @showHideLoading="showHideLoading"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import Businesses from 'src/components/Selects/Businesses.vue';
import i18n from 'src/i18n';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations.js';

export default {
  components: {
    [Businesses.name]: Businesses,
  },
  data() {
    return {
      articles: [],
      articleCategories: [],
      aticleByCategory: [],
      businessesInitial: [],
      businesses: [],
      model: {
        id: null,
        first_name: null,
        last_name: null,
        nit: null,
        bank_account: null,
        account_type: null,
        bank_name: null,
        articles_id: [],
        articles_names: [],
        articleCategories_id: [],
        businesses_id: [],
        businesses_names: [],
        isActiveArticle: true,
      },
      modelValidations: {
        first_name: { required: true },
        last_name: { required: true },
        nit: { required: true },
        bank_account: { required: true },
        bank_name: { required: true },
      },
    };
  },
  computed: {
    getTypeBankAccount() {
      return [
        {
          id: '1',
          value: 'Ahorro',
          label: i18n.t('inventory.savings'),
        },
        {
          id: '2',
          value: 'Corriente',
          label: i18n.t('inventory.checking'),
        },
      ];
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
  },
  mixins: [
    MixinPermissions,
    MixinForm,
    MixinAlert,
    MixinLoading,
    MixinValidations,
  ],
  methods: {
    getSelectAll() {
      this.articles = this.concatAll(this.articles.splice(1));
      this.articleCategories = this.concatAll(this.articleCategories.splice(1));
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
    getNameOfData(dataMain, options) {
      const others = [];
      dataMain.forEach((element) => {
        const isFind = options.find((item) => item.id === element);
        if (isFind) others.push(isFind.name);
      });

      return others;
    },
    articleByCategories() {
      this.aticleByCategory = this.articles.filter((article) =>
        this.model.articleCategories_id.includes(article.article_category_id)
      );
      this.aticleByCategory = this.concatAll(this.aticleByCategory);
      this.model.isActiveArticle = false;
    },
    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.account_type)) {
            return this.validationInputsRequired('account_type');
          } else if (this.model.articleCategories_id.length == 0) {
            return this.validationInputsRequired('articleCategories');
          } else if (this.model.articles_id.length == 0) {
            return this.validationInputsRequired('articles');
          } else if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('bus-rels');
          }
          this.model.articles_names = this.getNameOfData(
            this.model.articles_id,
            this.articles
          );
          this.$emit('on-validated', this.model);

          return isValid;
        }
      });
    },
  },
  mounted() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('inventory/article'),
        Axios.getMasters('inventory/articlecategory'),
        Axios.getMasters('businesses/only'),
      ])
        .then(
          ([
            response_articles,
            response_articleCategories,
            response_bussinesses,
          ]) => {
            this.articles = this.concatAll(response_articles.data.data);
            this.articleCategories = this.concatAll(
              response_articleCategories.data.data
            );
            this.businesses = response_bussinesses.data.data;
            const editForm = sessionStorage.getItem('editForm');
            if (this.isUpdate() && editForm) {
              const {
                id,
                first_name,
                last_name,
                nit,
                bank_account,
                account_type,
                bank_name,
                articles,
              } = JSON.parse(editForm);
              let articleCategoriesCopy = this.articleCategories.filter(
                (category) => category.id !== 0
              );
              const articleIds = articles.map((article) => article.id);
              const categoryIds = articleCategoriesCopy
                .filter((category) =>
                  category.articles.some((article) =>
                    articleIds.includes(article.id)
                  )
                )
                .map((category) => category.id);
              this.model.articleCategories_id = categoryIds;
              this.articleByCategories();
              this.model = {
                ...this.model,
                id,
                first_name,
                last_name,
                nit,
                bank_account,
                account_type,
                bank_name,
                articles_id: articles.map((r) => r.id),
              };
            }
            setTimeout(() => {
              this.showHideLoading();
            }, 1000);
          }
        )
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
  updated() {
    if (
      this.businesses &&
      this.businesses.length === 1 &&
      this.model.businesses_id.length === 0
    ) {
      this.model.businesses_id.push(this.businesses[0].id);
    }
  },
};
</script>
